export const DOMESTIC_COUNTRY_ID = 198
